import React from 'react';
import MainLayout from '@/components/layout/MainLayout';
import ResultsPagination from '@/components/search/ResultsPagination';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ExportPreRegistrationsButton } from '../components/ExportPreRegistrationsButton';
import { PreRegisteredAccommodationsFilters } from '../components/PreRegisteredAccommodationsFilters';
import { PreRegisteredAccommodationsTable } from '../components/PreRegisteredAccommodationsTable';
import { QueryStateMessage } from '../components/QueryStateMessage';
import {
  ACCOMMODATIONS_PAGE_SIZE,
  usePreRegisteredAccommodationSearch,
} from '../hooks/usePreRegisteredAccommodationSearch';

export const PreRegisteredAccommodationsPage: React.FC = () => {
  const { filters, filterParams, changeFilters, page, setPage, query } = usePreRegisteredAccommodationSearch();
  const { data, isLoading, isError, isFetching, refetch } = query;

  const total = data?.total ?? 0;
  const items = data?.items ?? [];
  const totalPages = Math.ceil(total / ACCOMMODATIONS_PAGE_SIZE);

  return (
    <MainLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Alojamientos preinscriptos</h1>
          <p className="mt-2 text-gray-600">
            Establecimientos informados por los municipios en sus listados de preinscripción
          </p>
        </div>

        <Card>
          <CardContent className="pt-6">
            <PreRegisteredAccommodationsFilters values={filters} onChange={changeFilters} />
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row flex-wrap items-center justify-between gap-2 space-y-0">
            <CardTitle>
              Resultados
              {data && (
                <span className="ml-2 text-sm font-normal text-gray-500">
                  ({total} {total === 1 ? 'alojamiento' : 'alojamientos'})
                </span>
              )}
            </CardTitle>
            <ExportPreRegistrationsButton params={filterParams} />
          </CardHeader>
          <CardContent>
            <QueryStateMessage
              isLoading={isLoading}
              isError={isError}
              isEmpty={items.length === 0}
              errorMessage="No se pudieron cargar los alojamientos preinscriptos."
              emptyMessage="No hay alojamientos preinscriptos que coincidan con los filtros."
              onRetry={() => refetch()}
            >
              <div className={`overflow-x-auto ${isFetching ? 'opacity-60' : ''}`}>
                <PreRegisteredAccommodationsTable items={items} />
              </div>
              {totalPages > 1 && (
                <div className="mt-4">
                  <ResultsPagination
                    currentPage={page}
                    totalPages={totalPages}
                    totalResults={total}
                    resultsPerPage={ACCOMMODATIONS_PAGE_SIZE}
                    onPageChange={setPage}
                  />
                </div>
              )}
            </QueryStateMessage>
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
};

export default PreRegisteredAccommodationsPage;
